// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"a8444c5a","821":"8ddffeee"}[chunkId] + ".chunk.js";
};